// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0ab54aca] .align-right .ag-header-cell-text{flex:1;text-align:right !important}", ""]);
// Exports
module.exports = exports;
